import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination'; // <-- import the module
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
//Funcionalidades
import { VideoLoadingComponent } from './components/shared/video-loading/video-loading.component';
import { SanitizerPipe } from './pipes/sanitizer.pipe';
import { HighlightsmodalPipe } from './pipes/highlightsmodal.pipe';
import { HideCollapseOnClickDirectiveComponent } from './components/header/hide-collapse-on-click-directive/hide-collapse-on-click-directive.component';
import { AlertComponent } from './components/util/alert/alert.component';
//Modulos
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UsersService } from './services/users.service';
import { authInterceptorProviders } from './_helpers/auth.interceptor';
import { HomeComponent } from './components/home/home.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoginComponent } from './components/login/login.component';
import { CarouselHomePubsComponent } from './components/util/carousel-home-pubs/carousel-home-pubs.component';
import { NewsComponent } from './components/news/news.component';
import { MeetingComponent } from './components/meeting/meeting.component';
import { PublicationComponent } from './components/publication/publication.component';
import { CarouselPubsComponent } from './components/util/carousel-pubs/carousel-pubs.component';
import { PublicationDetailComponent } from './components/publication/publication-detail/publication-detail.component';
import { NetworksComponent } from './components/networks/networks.component';
import { ForosFuturoComponent } from './components/foros-futuro/foros-futuro.component';
import { ForoDetalleComponent } from './components/foros-futuro/foro-detalle/foro-detalle.component';
import { SceneComponent } from './components/scene/scene.component';
import { CarouselComponent } from './components/util/carousel/carousel.component';
import { RadarComponent } from './components/radar/radar.component';
import { PodcastsComponent } from './components/podcasts/podcasts.component';
import { FichaComponent } from './components/shared/ficha/ficha.component';
import { CommentComponent } from './components/comments/comment/comment.component';
import { CommentFormComponent } from './components/comments/comment-form/comment-form.component';
import { CommentListComponent } from './components/comments/comment-list/comment-list.component';
import { TrendsComponent } from './components/trends/trends.component';
import { SearchContextualComponent } from './components/util/search/search-contextual/search-contextual.component';
import { GlobalComponent } from './components/trends/global/global.component';
import { NationalComponent } from './components/trends/national/national.component';
import { TerritorialComponent } from './components/trends/territorial/territorial.component';
import { SectorialComponent } from './components/trends/sectorial/sectorial.component';
import { ItemsComponent } from './components/trends/sectorial/items/items.component';
import { RiskComponent } from './components/risk/risk.component';
import { TerritorialesComponent } from './components/risk/territoriales/territoriales.component';
import { GlobalesComponent } from './components/risk/globales/globales.component';
import { ScatterComponent } from './components/shared/gr/scatter/scatter.component';
import { OppComponent } from './components/opp/opp.component';
import { GlobalopComponent } from './components/opp/globalop/globalop.component';
import { TerritorialopComponent } from './components/opp/territorialop/territorialop.component';
import { MegaComponent } from './components/mega/mega.component';
import { ForcemapComponent } from './components/forcemap/forcemap.component';
import { SearchBarComponent } from './components/util/search/search-global/search-bar/search-bar.component';
import { SearchResultComponent } from './components/util/search/search-global/search-result/search-result.component';
import { HighlightsPipe } from './pipes/highlights.pipe';
import { AdmComponent } from './components/adm/adm.component';
import { AdmtrendsComponent } from './components/adm/admtrends/admtrends.component';
import { GeneralFormComponent } from './components/adm/admtrends/adm-global-t/general-form/general-form.component';
import { GeneralListComponent } from './components/adm/admtrends/adm-global-t/general-list/general-list.component';
import { AdmsectionComponent } from './components/adm/shared/admsection/admsection.component';
import { AdmsectionFormComponent } from './components/adm/shared/admsection/admsection-form/admsection-form.component';
import { AdmsectionListComponent } from './components/adm/shared/admsection/admsection-list/admsection-list.component';
import { AdmsubsectionComponent } from './components/adm/shared/admsubsection/admsubsection.component';
import { AdmsubsectionListComponent } from './components/adm/shared/admsubsection/admsubsection-list/admsubsection-list.component';
import { AdmsubsectionFormComponent } from './components/adm/shared/admsubsection/admsubsection-form/admsubsection-form.component';
import { AdmsubsectionBlockFormComponent } from './components/adm/shared/admsubsection/admsubsection-block-form/admsubsection-block-form.component';
import { AdmgraphicComponent } from './components/adm/shared/admgraphic/admgraphic.component';
import { AdmgraphicFormComponent } from './components/adm/shared/admgraphic/admgraphic-form/admgraphic-form.component';
import { AdmgraphicListComponent } from './components/adm/shared/admgraphic/admgraphic-list/admgraphic-list.component';
import { AdmbiblioComponent } from './components/adm/shared/admbiblio/admbiblio.component';
import { AdmbiblioListComponent } from './components/adm/shared/admbiblio/admbiblio-list/admbiblio-list.component';
import { AdmbiblioFormComponent } from './components/adm/shared/admbiblio/admbiblio-form/admbiblio-form.component';
import { AdmbiblioBlockFormComponent } from './components/adm/shared/admbiblio/admbiblio-block-form/admbiblio-block-form.component';
import { AdmprimarysourceComponent } from './components/adm/shared/admprimarysource/admprimarysource.component';
import { AdmprimarysourceListComponent } from './components/adm/shared/admprimarysource/admprimarysource-list/admprimarysource-list.component';
import { AdmprimarysourceFormComponent } from './components/adm/shared/admprimarysource/admprimarysource-form/admprimarysource-form.component';
import { AdmFormIntroInfoComponent } from './components/adm/shared/adm-form-intro-info/adm-form-intro-info.component';
import { AdmFormDocDptoComponent } from './components/adm/shared/adm-form-doc-dpto/adm-form-doc-dpto.component';
import { AdmFormDocSectorComponent } from './components/adm/shared/adm-form-doc-sector/adm-form-doc-sector.component';
import { AdmrisksComponent } from './components/adm/admrisks/admrisks.component';
import { T1RComponent } from './components/adm/admrisks/t1-r/t1-r.component';
import { T1RFormComponent } from './components/adm/admrisks/t1-r/t1-r-form/t1-r-form.component';
import { T1RListComponent } from './components/adm/admrisks/t1-r/t1-r-list/t1-r-list.component';
import { AdmScatterComponent } from './components/adm/shared/adm-scatter-graph/adm-scatter/adm-scatter.component';
import { AdmFormScatterGraphComponent } from './components/adm/shared/adm-scatter-graph/adm-form-scatter-graph/adm-form-scatter-graph.component';
import { AdmModalScatterPeriodComponent } from './components/adm/shared/adm-scatter-graph/adm-modal-scatter-period/adm-modal-scatter-period.component';
import { AdmopportunitiesComponent } from './components/adm/admopportunities/admopportunities.component';
import { T1OFormComponent } from './components/adm/admopportunities/t1-o/t1-o-form/t1-o-form.component';
import { T1OListComponent } from './components/adm/admopportunities/t1-o/t1-o-list/t1-o-list.component';
import { AdmmegaComponent } from './components/adm/admmega/admmega.component';
import { AdmmegaListComponent } from './components/adm/admmega/admmega-list/admmega-list.component';
import { AdmmegaFormComponent } from './components/adm/admmega/admmega-form/admmega-form.component';
import { AdmmegaInterrelationshipFormComponent } from './components/adm/admmega/admmega-interrelationship-form/admmega-interrelationship-form.component';
import { AdmsceneComponent } from './components/adm/admscene/admscene.component';
import { AdmsceneListComponent } from './components/adm/admscene/admscene-list/admscene-list.component';
import { AdmsceneFormComponent } from './components/adm/admscene/admscene-form/admscene-form.component';
import { AdmsignalComponent } from './components/adm/admsignal/admsignal.component';
import { AdmsignalListComponent } from './components/adm/admsignal/admsignal-list/admsignal-list.component';
import { AdmsignalFormComponent } from './components/adm/admsignal/admsignal-form/admsignal-form.component';
import { AdmnewsComponent } from './components/adm/admnews/admnews.component';
import { AdmnewsListComponent } from './components/adm/admnews/admnews-list/admnews-list.component';
import { AdmnewsFormComponent } from './components/adm/admnews/admnews-form/admnews-form.component';
import { AdmmeetingComponent } from './components/adm/admmeeting/admmeeting.component';
import { AdmmeetingListComponent } from './components/adm/admmeeting/admmeeting-list/admmeeting-list.component';
import { AdmmeetingFormComponent } from './components/adm/admmeeting/admmeeting-form/admmeeting-form.component';
import { AdmcontentComponent } from './components/adm/shared/admcontent/admcontent.component';
import { AdmcontentListComponent } from './components/adm/shared/admcontent/admcontent-list/admcontent-list.component';
import { AdmcontentFormComponent } from './components/adm/shared/admcontent/admcontent-form/admcontent-form.component';
import { AdmprimaryforceComponent } from './components/adm/admprimaryforce/admprimaryforce.component';
import { AdmprimaryforceListComponent } from './components/adm/admprimaryforce/admprimaryforce-list/admprimaryforce-list.component';
import { AdmprimaryforceFormComponent } from './components/adm/admprimaryforce/admprimaryforce-form/admprimaryforce-form.component';
import { AdmtechComponent } from './components/adm/admtech/admtech.component';
import { AdmtechListComponent } from './components/adm/admtech/admtech-list/admtech-list.component';
import { AdmtechFormComponent } from './components/adm/admtech/admtech-form/admtech-form.component';
import { AdmtematicsComponent } from './components/adm/admtematics/admtematics.component';
import { AdmtematicsListComponent } from './components/adm/admtematics/admtematics-list/admtematics-list.component';
import { AdmtematicsFormComponent } from './components/adm/admtematics/admtematics-form/admtematics-form.component';
import { AdmpublicationsComponent } from './components/adm/admpublications/admpublications.component';
import { AdmpublicationsListComponent } from './components/adm/admpublications/admpublications-list/admpublications-list.component';
import { AdmpublicationsFormComponent } from './components/adm/admpublications/admpublications-form/admpublications-form.component';
import { AdmpublicationsFormPdfComponent } from './components/adm/admpublications/admpublications-form-pdf/admpublications-form-pdf.component';
import { AdmpublicationsFormYoutubeComponent } from './components/adm/admpublications/admpublications-form-youtube/admpublications-form-youtube.component';
import { AdmpublicationsFormCarouselComponent } from './components/adm/admpublications/admpublications-form-carousel/admpublications-form-carousel.component';
import { AdmpodcastComponent } from './components/adm/admpodcast/admpodcast.component';
import { AdmpodcastListComponent } from './components/adm/admpodcast/admpodcast-list/admpodcast-list.component';
import { AdmpodcastFormComponent } from './components/adm/admpodcast/admpodcast-form/admpodcast-form.component';
import { AdmnetworksComponent } from './components/adm/admnetworks/admnetworks.component';
import { AdmnetworksListComponent } from './components/adm/admnetworks/admnetworks-list/admnetworks-list.component';
import { AdmnetworksFormComponent } from './components/adm/admnetworks/admnetworks-form/admnetworks-form.component';
import { AdmforumsComponent } from './components/adm/admforums/admforums.component';
import { AdmforumsListComponent } from './components/adm/admforums/admforums-list/admforums-list.component';
import { AdmforumsFormComponent } from './components/adm/admforums/admforums-form/admforums-form.component';
import { AdmuserComponent } from './components/adm/admuser/admuser.component';
import { AdmuserFormComponent } from './components/adm/admuser/admuser-form/admuser-form.component';
import { AdmuserListComponent } from './components/adm/admuser/admuser-list/admuser-list.component';
import { AdmuserPermissionComponent } from './components/adm/admuser/admuser-permission/admuser-permission.component';
import { AdmreportComponent } from './components/adm/admreport/admreport.component';
import { AdmcommentComponent } from './components/adm/admcomment/admcomment.component';
import { AdmcommentListComponent } from './components/adm/admcomment/admcomment-list/admcomment-list.component';
import { HeaderSurveyComponent } from './components/survey/header-survey/header-survey.component';
import { ExternalsurveyComponent } from './components/survey/externalsurvey/externalsurvey.component';
import { InvestigationComponent } from './components/survey/investigation/investigation.component';
import { MonitoringComponent } from './components/survey/monitoring/monitoring.component';
import { PreviewComponent } from './components/survey/preview/preview.component';
import { TestpreviewComponent } from './components/survey/testpreview/testpreview.component';
import { OrganizationComponent } from './components/survey/organization/organization.component';
import { PermissionsComponent } from './components/survey/organization/permissions/permissions.component';
import { QuestionTypeComponent } from './components/survey/organization/question-type/question-type.component';
import { SvStatusComponent } from './components/survey/organization/sv-status/sv-status.component';
import { TeamComponent } from './components/survey/organization/team/team.component';
import { PermissionsFormComponent } from './components/survey/organization/permissions/permissions-form.component';
import { PermissionsListComponent } from './components/survey/organization/permissions/permissions-list.component';
import { QuestionTypeFormComponent } from './components/survey/organization/question-type/question-type-form.component';
import { QuestionTypeListComponent } from './components/survey/organization/question-type/question-type-list.component';
import { SvStatusFormComponent } from './components/survey/organization/sv-status/sv-status-form.component';
import { SvStatusListComponent } from './components/survey/organization/sv-status/sv-status-list.component';
import { TeamFormComponent } from './components/survey/organization/team/team-form.component';
import { TeamListComponent } from './components/survey/organization/team/team-list.component';
import { UsersSurveyListComponent } from './components/survey/organization/team/users-survey-list.component';
import { UsersSurveyFormComponent } from './components/survey/organization/team/users-survey-form.component';
import { SurveysComponent } from './components/survey/surveys/surveys.component';
import { SurveysFormComponent } from './components/survey/surveys/surveys-form.component';
import { SurveysListComponent } from './components/survey/surveys/surveys-list.component';
import { SurveysPageComponent } from './components/survey/surveys/surveys-page.component';
import { SvsectionComponent } from './components/survey/surveys/svsection/svsection.component';
import { SvsectionFormComponent } from './components/survey/surveys/svsection/svsection-form/svsection-form.component';
import { SvsectionListComponent } from './components/survey/surveys/svsection/svsection-list/svsection-list.component';
import { SvquestionComponent } from './components/survey/surveys/svsection/svquestion/svquestion.component';
import { SvoptionComponent } from './components/survey/surveys/svsection/svquestion/svoption/svoption.component';
import { SvquestionFormComponent } from './components/survey/surveys/svsection/svquestion/svquestion-form/svquestion-form.component';
import { SvquestionListComponent } from './components/survey/surveys/svsection/svquestion/svquestion-list/svquestion-list.component';
import { SvaxisComponent } from './components/survey/surveys/svsection/svquestion/svoption/svaxis/svaxis.component';
import { SvaxisFormComponent } from './components/survey/surveys/svsection/svquestion/svoption/svaxis/svaxis-form/svaxis-form.component';
import { SvaxisListComponent } from './components/survey/surveys/svsection/svquestion/svoption/svaxis/svaxis-list/svaxis-list.component';
import { SvoptionFormComponent } from './components/survey/surveys/svsection/svquestion/svoption/svoption-form/svoption-form.component';
import { SvoptionListComponent } from './components/survey/surveys/svsection/svquestion/svoption/svoption-list/svoption-list.component';
import { AdmsheetComponent } from './components/adm/admsheet/admsheet.component';
import { AdmsheetListComponent } from './components/adm/admsheet/admsheet-list/admsheet-list.component';
import { AdmsheetFormComponent } from './components/adm/admsheet/admsheet-form/admsheet-form.component';
import { QuillModule } from 'ngx-quill';
import { FichaTestComponent } from './components/shared/ficha-test/ficha-test.component';
import { FichaHistorialComponent } from './components/shared/ficha-historial/ficha-historial.component';
import { SuscriptionComponent } from './components/shared/suscription/suscription.component';
import { AdmsuscriptionComponent } from './components/adm/admsuscription/admsuscription.component';
import { AdmsuscriptionListComponent } from './components/adm/admsuscription/admsuscription-list/admsuscription-list.component';
import { AdmsuscriptionFormComponent } from './components/adm/admsuscription/admsuscription-form/admsuscription-form.component';


registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    SanitizerPipe,
    HighlightsmodalPipe,
    HighlightsPipe,
    VideoLoadingComponent,
    HideCollapseOnClickDirectiveComponent,
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    CarouselHomePubsComponent,
    NewsComponent,
    MeetingComponent,
    PublicationComponent,
    CarouselPubsComponent,
    PublicationDetailComponent,
    NetworksComponent,
    ForosFuturoComponent,
    ForoDetalleComponent,
    SceneComponent,
    CarouselComponent,
    RadarComponent,
    PodcastsComponent,
    FichaComponent,
    CommentComponent,
    CommentFormComponent,
    CommentListComponent,
    TrendsComponent,
    SearchContextualComponent,
    GlobalComponent,
    NationalComponent,
    TerritorialComponent,
    SectorialComponent,
    ItemsComponent,
    RiskComponent,
    TerritorialesComponent,
    GlobalesComponent,
    ScatterComponent,
    OppComponent,
    GlobalopComponent,
    TerritorialopComponent,
    MegaComponent,
    ForcemapComponent,
    SearchBarComponent,
    SearchResultComponent,
    AdmComponent,
    AdmtrendsComponent,
    GeneralFormComponent,
    GeneralListComponent,
    AdmsectionComponent,
    AdmsectionFormComponent,
    AdmsectionListComponent,
    AdmsubsectionComponent,
    AdmsubsectionListComponent,
    AdmsubsectionFormComponent,
    AdmsubsectionBlockFormComponent,
    AdmgraphicComponent,
    AdmgraphicFormComponent,
    AdmgraphicListComponent,
    AdmbiblioComponent,
    AdmbiblioListComponent,
    AdmbiblioFormComponent,
    AdmbiblioBlockFormComponent,
    AdmprimarysourceComponent,
    AdmprimarysourceListComponent,
    AdmprimarysourceFormComponent,
    AdmFormIntroInfoComponent,
    AdmFormDocDptoComponent,
    AdmFormDocSectorComponent,
    AdmrisksComponent,
    T1RComponent,
    T1RFormComponent,
    T1RListComponent,
    AdmScatterComponent,
    AdmFormScatterGraphComponent,
    AdmModalScatterPeriodComponent,
    AdmopportunitiesComponent,
    T1OFormComponent,
    T1OListComponent,
    AdmmegaComponent,
    AdmmegaListComponent,
    AdmmegaFormComponent,
    AdmmegaInterrelationshipFormComponent,
    AdmsceneComponent,
    AdmsceneListComponent,
    AdmsceneFormComponent,
    AdmsignalComponent,
    AdmsignalListComponent,
    AdmsignalFormComponent,
    AdmnewsComponent,
    AdmnewsListComponent,
    AdmnewsFormComponent,
    AdmmeetingComponent,
    AdmmeetingListComponent,
    AdmmeetingFormComponent,
    AdmcontentComponent,
    AdmcontentListComponent,
    AdmcontentFormComponent,
    AdmprimaryforceComponent,
    AdmprimaryforceListComponent,
    AdmprimaryforceFormComponent,
    AdmtechComponent,
    AdmtechListComponent,
    AdmtechFormComponent,
    AdmtematicsComponent,
    AdmtematicsListComponent,
    AdmtematicsFormComponent,
    AdmpublicationsComponent,
    AdmpublicationsListComponent,
    AdmpublicationsFormComponent,
    AdmpublicationsFormPdfComponent,
    AdmpublicationsFormYoutubeComponent,
    AdmpublicationsFormCarouselComponent,
    AdmpodcastComponent,
    AdmpodcastListComponent,
    AdmpodcastFormComponent,
    AdmnetworksComponent,
    AdmnetworksListComponent,
    AdmnetworksFormComponent,
    AdmforumsComponent,
    AdmforumsListComponent,
    AdmforumsFormComponent,
    AdmuserComponent,
    AdmuserFormComponent,
    AdmuserListComponent,
    AdmuserPermissionComponent,
    AdmreportComponent,
    AdmcommentComponent,
    AdmcommentListComponent,
    HeaderSurveyComponent,
    ExternalsurveyComponent,
    InvestigationComponent,
    MonitoringComponent,
    PreviewComponent,
    TestpreviewComponent,
    OrganizationComponent,
    PermissionsComponent,
    QuestionTypeComponent,
    SvStatusComponent,
    TeamComponent,
    PermissionsFormComponent,
    PermissionsListComponent,
    QuestionTypeFormComponent,
    QuestionTypeListComponent,
    SvStatusFormComponent,
    SvStatusListComponent,
    TeamFormComponent,
    TeamListComponent,
    UsersSurveyListComponent,
    UsersSurveyFormComponent,
    SurveysComponent,
    SurveysFormComponent,
    SurveysListComponent,
    SurveysPageComponent,
    SvsectionComponent,
    SvsectionFormComponent,
    SvsectionListComponent,
    SvquestionComponent,
    SvoptionComponent,
    SvquestionFormComponent,
    SvquestionListComponent,
    SvaxisComponent,
    SvaxisFormComponent,
    SvaxisListComponent,
    SvoptionFormComponent,
    SvoptionListComponent,
    AlertComponent,
    ItemsComponent,
    AdmsheetComponent,
    AdmsheetListComponent,
    AdmsheetFormComponent,
    FichaTestComponent,
    FichaHistorialComponent,
    SuscriptionComponent,
    AdmsuscriptionComponent,
    AdmsuscriptionListComponent,
    AdmsuscriptionFormComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NgxPaginationModule,
    QuillModule.forRoot(),
    BrowserAnimationsModule
  ],
  providers: [
    authInterceptorProviders,
    UsersService,
    { provide: LOCALE_ID, useValue: 'es' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
